export const BlockEventType = {
  ACTION_EXECUTED: 'ACTION_EXECUTED',
  DATA_LOADED: 'DATA_LOADED',
  SELECTION_CHANGED: 'SELECTION_CHANGED',
  ROW_CLICKED: 'ROW_CLICKED',
  SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
  SUBMIT_FAILURE: 'SUBMIT_FAILURE',
  VALUES_CHANGED: 'VALUES_CHANGED',
  VIEW_LOADED: 'VIEW_LOADED',
  EDIT_STATE_CHANGED: 'EDIT_STATE_CHANGED',
  ROW_SAVED: 'ROW_SAVED',
  ARRAY_CHANGED: 'ARRAY_CHANGED',
  WIZARD_STEP_COMPLETE: 'WIZARD_STEP_COMPLETE',
  TAB_CHANGED: 'TAB_CHANGED',
  CUSTOM: 'CUSTOM',
} as const;

export type BlockEventType = (typeof BlockEventType)[keyof typeof BlockEventType];

export const DeliveryProtocol = {
  REFRESH: 'refresh',
  PARAM: 'param',
  COMMAND: 'command',
  DERIVED: 'derived',
} as const;

export type DeliveryProtocol = (typeof DeliveryProtocol)[keyof typeof DeliveryProtocol];

export const BlockType = {
  TABLE: 'table',
  FORM: 'form',
  VIEW: 'view',
  TAB: 'tab',
} as const;

export type BlockType = (typeof BlockType)[keyof typeof BlockType];
